// extracted by mini-css-extract-plugin
export default {"newsBlock":"NewsBlock_newsBlock__Aw19I","newsBlock_container":"NewsBlock_newsBlock_container__f6mJR"};